import { useEffect, useState } from "react";
import { Loader2, DollarSign, CreditCard, Users, FileText, CheckCircle2, RefreshCw, Ban } from "lucide-react";
import api from "@/lib/api";
import { ferr, money } from "../shared";

export default function Overview() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch((e) => ferr(e, "Failed to load stats.")); }, []);
  if (!stats) return <div className="grid place-items-center py-16"><Loader2 className="animate-spin text-mortar" /></div>;
  const cards = [
    ["Revenue (paid)", money(stats.revenue), DollarSign],
    ["Paid orders", stats.paid_orders, CreditCard],
    ["Customers", stats.users, Users],
    ["Reports", stats.reports_total, FileText],
    ["Complete", stats.reports_complete, CheckCircle2],
    ["Processing", stats.reports_processing, RefreshCw],
    ["Failed", stats.reports_failed, Ban],
    ["Awaiting payment", stats.reports_pending, CreditCard],
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-overview">
      {cards.map(([label, val, Icon]) => (
        <div key={label} className="card-mtr !p-4">
          <Icon size={18} className="text-mortar mb-2" />
          <p className="text-[26px] font-extrabold text-navy leading-none">{val}</p>
          <p className="text-[12px] text-mortar mt-1">{label}</p>
        </div>
      ))}
    </div>
  );
}
